import React from 'react';
import {Box, FormControl} from 'native-base';

import {message as t} from '../../../../utils/messages';
import {useNavigation} from '@react-navigation/native';
import {StackParamList} from '../../../../navigators';
import {NativeStackNavigationProp} from '@react-navigation/native-stack';
import SearchInput from '../input/SearchInput';

interface InputProps {
  onChange?: (value: string) => void;
  label: string;
  onPress?: () => void;
  navigateTo: any;
  defaultValue?: string;
}

export const SearchInputLauncher = ({
  onChange: launcheOnChange,
  label,
  navigateTo,
  defaultValue,
}: InputProps) => {
  const navigation = useNavigation<NativeStackNavigationProp<StackParamList>>();

  const handleOnPressIn = () => {
    navigation.navigate(navigateTo);
  };

  const handleOnChange = (value: string) => {
    if (launcheOnChange) {
      launcheOnChange(value);
    }
  };

  return (
    <Box width="100%" marginBottom={5}>
      <FormControl>
        <FormControl.Label>{t(label)}</FormControl.Label>
        <SearchInput
          onChange={handleOnChange}
          onPress={handleOnPressIn}
          readonly={true}
          defaultValue={defaultValue}
        />
      </FormControl>
    </Box>
  );
};
